import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b9115da0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "guide-page"
};
const _hoisted_2 = {
  class: "guide-page-footer"
};
import { computed, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import guideData from './guide_data.json';
import GuideRenderer from '@/components/guide/GuideRenderer.vue';
import domain from "@/service/domain";
import env from "md-base-tools/env";
// import graft from 'md-base-tools/graft'
import { QuickCopy } from '@/utils/tools';
// import GuideTitle from '@/components/guide/Title.vue'

export default {
  setup(__props) {
    const router = useRouter();
    const go = key => {
      if (key === 'activity') {
        // 任务中心
        router.push({
          path: `/score/task/index`
        });
        // graft.app({
        //     functionName: "openController",
        //     functionParams: `${domain.wap}/score/task/index`,
        //     webFun: () => {
        //         router.push({
        //             path: `/score/task/index`
        //         })
        //     }
        // })
      } else if (key === 'creativity') {
        // 发布创意
        router.push({
          path: `/idea/create`
        });
        // graft.app({
        //     functionName: "openController",
        //     functionParams: `md://publishIdea`,
        //     webFun: () => {
        //         router.push({
        //             path: `/idea/create`,
        //         })
        //     }
        // })
      } else if (key === 'rednote') {
        QuickCopy(`https://member.modian.com/operate_manage/drawtool/create_rednote`);
      } else if (key === 'draw') {
        QuickCopy(`https://member.modian.com/operate_manage/drawtool/initiate`);
      }
    };
    const route = useRoute();
    const currentKey = computed(() => String(route.params.slug || '').trim());
    const pageConfig = computed(() => {
      const key = currentKey.value;
      if (key && guideData[key]) return guideData[key];
      return {
        title: '用户指引',
        content: []
      };
    });
    const pageTitle = computed(() => pageConfig.value.title || '用户指引');
    const items = computed(() => pageConfig.value.content || []);
    const share_url = `${domain.wap}/guide/operation`;
    const share_des = '点这里！查看发起项目完整步骤';
    const shareInfo = {
      active_title: "",
      img: "https://p6.moimg.net/mdwxapp/md_logo.png",
      mina_app_name: "",
      // gh_5638b10d3ccb
      mina_share_img: "",
      mina_share_path: ``,
      msg_des: share_des,
      qq_des: share_des,
      qq_share_url: share_url,
      qq_title: share_des,
      qr_img: "https://p6.moimg.net/mdwxapp/md_logo.png",
      qzone_share_url: share_url,
      share_url: share_url,
      sharelink_url: share_url,
      small_code: "",
      weibo_des: share_des + share_url + '（分享自@摩点）',
      weibo_share_url: share_url,
      weibo_title: share_des,
      weixin_share_url: share_url,
      wxTimeline_share_url: share_url,
      wx_des: '',
      wx_title: share_des
    };
    onMounted(() => {
      document.title = pageTitle.value;
      if (currentKey.value === 'operation' && (env.isModianIos() || env.isModianAndroid())) {
        // eslint-disable-next-line no-undef
        graft.app({
          functionName: 'webShareEnabled',
          functionParams: JSON.parse(JSON.stringify({
            shareEnabled: '1',
            shareInfo: shareInfo
          }))
        });
      }
    });
    watch(pageTitle, val => {
      if (val) document.title = val;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(items) && _unref(items).length ? (_openBlock(), _createBlock(GuideRenderer, {
        key: 0,
        items: _unref(items)
      }, null, 8, ["items"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_unref(currentKey) === 'creativity' ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "guide-page-footer-btn",
        onClick: _cache[0] || (_cache[0] = $event => go('creativity'))
      }, " 去发布创意 ")) : _createCommentVNode("", true), _unref(currentKey) === 'draw' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "guide-page-footer-btn",
        onClick: _cache[1] || (_cache[1] = $event => go('draw'))
      }, " 复制链接去电脑端发布抽奖活动 ")) : _createCommentVNode("", true), _unref(currentKey) === 'rednote' ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "guide-page-footer-btn",
        onClick: _cache[2] || (_cache[2] = $event => go('rednote'))
      }, " 复制链接去电脑端发布种草活动 ")) : _createCommentVNode("", true), _unref(currentKey) === 'advert_space' ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "guide-page-footer-btn",
        onClick: _cache[3] || (_cache[3] = $event => go('activity'))
      }, " 去获取金币 ")) : _createCommentVNode("", true), _unref(currentKey) === 'activity' ? (_openBlock(), _createElementBlock("div", {
        key: 4,
        class: "guide-page-footer-btn",
        onClick: _cache[4] || (_cache[4] = $event => go('activity'))
      }, " 前往任务中心 ")) : _createCommentVNode("", true)])]);
    };
  }
};